interface EmptyStateProps {
    message: string;
    icon?: 'info' | 'search' | 'inbox' | 'list' | 'heart' | 'document';
    subMessage?: string;
    actionButton?: {
        text: string;
        onClick: () => void;
    };
    className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
                                                          message,
                                                          icon = '',
                                                          subMessage,
                                                          actionButton,
                                                          className = ''
                                                      }) => {
    const getIconClass = () => {
        switch(icon) {
            //추후 아이콘 고도화시 활용
        }
    };

    return (
        <section className={className}>
            <div className="inner">
                <div className="no_result">
                    <span className="ico_wrap">
                        <i className={`ico_point fa-solid ${getIconClass()}`}></i>
                    </span>
                    <p>{message}</p>
                    {subMessage && <p className="sub-message">{subMessage}</p>}
                    {actionButton && (
                        <button
                            type="button"
                            className="btn confirm mt20"
                            onClick={actionButton.onClick}
                        >
                            {actionButton.text}
                        </button>
                    )}
                </div>
            </div>
        </section>
    );
};